import { Link, type NotFoundRouteProps } from "@tanstack/react-router"
import { AnimatePresence, motion } from "motion/react"

import { AuroraBackground } from "@repo/ui/components/ui/aurora-background"
import { buttonVariants } from "@repo/ui/components/ui/button"
import { cn } from "@repo/ui/lib/utils"

export function NotFound({ data }: NotFoundRouteProps) {
  const errorMessage =
    typeof data === "object" &&
    data !== null &&
    "message" in data &&
    typeof data.message === "string"
      ? data.message
      : "The page you are looking for does not exist."

  return (
    <AnimatePresence mode="wait">
      <AuroraBackground>
        <motion.div
          className="relative z-10 flex w-full max-w-md flex-col items-center justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <motion.div
            className="relative w-full"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{
              type: "spring",
              stiffness: 100,
              damping: 15,
            }}
          >
            <div className="flex grow flex-col items-center justify-center space-y-2 p-2 text-white">
              <h1 className="font-bold text-2xl">Page Not Found</h1>
              <div className="text-white/70">{errorMessage}</div>
              <p className="flex flex-wrap items-center gap-2">
                <button
                  type="button"
                  onClick={() => window.history.back()}
                  className={cn(buttonVariants({ variant: "outline" }))}
                >
                  Go back
                </button>
                <Link
                  to="/"
                  className={cn(buttonVariants({ variant: "secondary" }))}
                >
                  Start Over
                </Link>
              </p>
            </div>
          </motion.div>
        </motion.div>
      </AuroraBackground>
    </AnimatePresence>
  )
}
